import * as React from "react";

// component with salaryperiod select

import * as salaryPeriodTypeService from "../../services/salaryPeriodTypeService";
import MuiSelect from "../framework/muiSelect";
import { Base } from "../../framework/base";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ISalaryPeriodItem } from "../../models/salaryPeriod/salaryPeriodItem";
import { WarningAmber } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { handleApiError } from "../../models/store/storeEffects";
import { useAppDispatch } from "../../framework/customStore";
import { SalaryPeriodTypeItem } from "../../models/salaryPeriodType/salaryPeriodTypeItem";

interface SalaryPeriodSelectProps {
    salaryPeriods: ISalaryPeriodItem[];
    selectedSalaryPeriod: ISalaryPeriodItem;
    onChange: (salaryPeriod: ISalaryPeriodItem) => void;
    size?: "small" | "medium";
}
// using muiselect
export const SalaryPeriodSelect = (props: SalaryPeriodSelectProps) => {
    const { t } = useTranslation();
    const { salaryPeriods,
        selectedSalaryPeriod,
        onChange,
        size,
    } = props;
    const dispatch = useAppDispatch();

    const salaryPeriodChanged = React.useCallback((salaryPeriodId: string) => {
        onChange(salaryPeriods.find(x => x.id === salaryPeriodId));
    }, [onChange, salaryPeriods]);

    const [prevDisabled, setPrevDisabled] = React.useState<boolean>(false);
    const [nextDisabled, setNextDisabled] = React.useState<boolean>(false);
    const [missingSalaryPeriodWarningVisible, setMissingSalaryPeriodWarningVisible] =
        React.useState<boolean>(false);
    const [salaryperiodType, setSalaryperiodType] = React.useState<SalaryPeriodTypeItem>(null);

    React.useEffect(() => {
        if (!salaryPeriods || salaryPeriods.length === 0 || !selectedSalaryPeriod) {
            return;
        }
        const index = salaryPeriods.findIndex(x => x.id === selectedSalaryPeriod.id);
        setPrevDisabled(index === 0);
        setNextDisabled(index === salaryPeriods.length - 1);
    }, [salaryPeriods, selectedSalaryPeriod]);

    function handlePrev() {
        const index = salaryPeriods.findIndex(x => x.id === selectedSalaryPeriod.id);
        if (index > 0) {
            onChange(salaryPeriods[index - 1]);
        }
    }

    function handleNext() {
        const index = salaryPeriods.findIndex(x => x.id === selectedSalaryPeriod.id);
        if (index < salaryPeriods.length - 1) {
            onChange(salaryPeriods[index + 1]);
        }
    }

    const fetchSalaryPeriodType = () => {
        if (salaryPeriods && salaryPeriods.length > 0) {
            salaryPeriodTypeService
                .getSalaryPeriodTypeItem(salaryPeriods[0].salaryPeriodTypeId)
                .then((res) => setSalaryperiodType(res))
                .catch((e) => handleApiError(e, dispatch));
        }
    };

    React.useEffect(() => {
        if (salaryPeriods) {
            fetchSalaryPeriodType();

            const currentSalaryPeriod = salaryPeriods.find((p) => Base.isBetween(
                new Date(),
                p.startDate,
                p.endDate,
                "day",
                "[]"
            ));

            if (currentSalaryPeriod) {
                setMissingSalaryPeriodWarningVisible(false);
            } else {
                setMissingSalaryPeriodWarningVisible(true);
            }
        }
    }, [salaryPeriods]);

    if (!salaryPeriods || salaryPeriods.length === 0) {
        return (
            <Grid2 container alignItems="center">
                <Tooltip title={t("currentSalaryPeriodMissing", {
                    name: ""
                })}
                >
                    <IconButton
                        color="primary"
                    >
                        <WarningAmber />
                    </IconButton>
                </Tooltip>
            </Grid2>
        );
    }

    if (!selectedSalaryPeriod) {
        return null;
    }

    return (
        <Grid2 container alignItems="center" minWidth={280}>
            <Grid2>
                <MuiSelect
                    size={size}
                    options={salaryPeriods.map((x) => ({
                        label:
                            Base.dayjsToDateStr(x.startDate) +
                            "-" +
                            Base.dayjsToDateStr(x.endDate),
                        value: x.id,
                    }))}
                    defaultValue={selectedSalaryPeriod.id}
                    label={t("salaryPeriod")}
                    onChange={salaryPeriodChanged}
                    maxHeight={300}
                />
            </Grid2>
            <Grid2>
                <IconButton
                    size={size}
                    color="primary"
                    onClick={() => handlePrev()}
                    disabled={prevDisabled}
                >
                    <ArrowBackIcon fontSize="inherit" />
                </IconButton>
                <IconButton
                    size={size}
                    color="primary"
                    onClick={() => handleNext()}
                    disabled={nextDisabled}
                >
                    <ArrowForwardIcon fontSize="inherit" />
                </IconButton>
                {missingSalaryPeriodWarningVisible &&
                    <Tooltip title={t("currentSalaryPeriodMissing", {
                        name: salaryperiodType?.name
                    })}
                    >
                        <IconButton
                            color="primary"
                        >
                            <WarningAmber />
                        </IconButton>
                    </Tooltip>
                }
            </Grid2>
        </Grid2>
    );
};
